import { useAuth0 } from "@auth0/auth0-react";
import { useToastContext } from "@ttc3k/trekker";
import { useUserRequestEmailVerificationLazyQuery } from "gql/generated";
import { useState } from "react";
import { useTranslation } from "react-i18next";

export const useDoorstopLayout = () => {
  const { t } = useTranslation("core");
  const { toastFactory } = useToastContext();
  const { user } = useAuth0();

  const [requestEmailVerification] = useUserRequestEmailVerificationLazyQuery();

  const [isSendingEmailVerification, setIsSendingEmailVerification] =
    useState(false);

  const [showEmailVerificationPrompt, setShowEmailVerificationPrompt] =
    useState(!user?.email_verified);

  /**
   * When the link to send the verification is clicked, it will
   * create an emial verification ticket request with Auth0
   * (similar to the password reset ticket) and an email will be
   * sent via SendGrid with that the URL returned from the
   * verification ticket
   */
  const handleSendVerificationEmail = async () => {
    setIsSendingEmailVerification(true);
    const response = await requestEmailVerification();
    setIsSendingEmailVerification(false);

    if (response) {
      toastFactory.create({
        title: t("core:SUCCESS"),
        description: t("core:DOORSTOP.VERIFY_EMAIL.SUCCESS"),
      });
      setShowEmailVerificationPrompt(false);
    } else {
      toastFactory.create({
        title: t("core:ERROR.TITLE"),
        description: t("core:DOORSTOP.VERIFY_EMAIL.ERROR"),
      });
    }
  };

  return {
    isSendingEmailVerification,
    showEmailVerificationPrompt,
    handleSendVerificationEmail,
  };
};
